import React, { useState } from 'react';
import { Mail } from 'lucide-react';
import { COLORS } from '../../../../utils/constants';
import { adminAPI } from '../../../../services/api';
import { useAdminToast } from '../../../../hooks/useAdminToast';
import { ModalWrapper } from './ModalComponents';

const MassEmailModal = ({ selectedClients, onClose, onSuccess }) => {
  const { toast } = useAdminToast();
  const [subject, setSubject] = useState('');
  const [body, setBody] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const handleSend = async () => {
    if (!subject.trim() || !body.trim()) {
      toast.validation('Заполните тему и текст письма');
      return;
    }

    setLoading(true);
    try {
      const res = await adminAPI.massEmail(selectedClients, subject, body);
      setResult(res.data);
      setTimeout(() => {
        onSuccess();
      }, 2000);
    } catch (err) {
      toast.apiError(err, 'Не удалось отправить');
    } finally {
      setLoading(false);
    }
  };

  return (
    <ModalWrapper title="Массовая рассылка Email" onClose={onClose} maxWidth="500px">
      <div style={{ marginBottom: '16px', color: COLORS.textSecondary, fontSize: '13px' }}>
        Отправка email <strong style={{ color: COLORS.text }}>{selectedClients.length}</strong> клиентам
      </div>

      <div style={{ 
        padding: '12px', 
        backgroundColor: COLORS.background, 
        borderRadius: '8px', 
        marginBottom: '16px',
        fontSize: '12px',
        color: COLORS.textSecondary 
      }}>
        <strong>Переменные:</strong> {'{name}'} - имя клиента, {'{email}'} - email клиента
      </div>

      <div style={{ marginBottom: '12px' }}>
        <label style={{ display: 'block', color: COLORS.textSecondary, fontSize: '13px', marginBottom: '6px' }}>
          Тема письма *
        </label>
        <input
          type="text"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
          placeholder="Тема email"
          style={{
            width: '100%',
            padding: '12px',
            backgroundColor: COLORS.background,
            border: `1px solid ${COLORS.border}`,
            borderRadius: '8px',
            color: COLORS.text,
            fontSize: '14px',
            boxSizing: 'border-box'
          }}
        />
      </div>

      <div style={{ marginBottom: '16px' }}>
        <label style={{ display: 'block', color: COLORS.textSecondary, fontSize: '13px', marginBottom: '6px' }}>
          Текст письма *
        </label>
        <textarea
          value={body}
          onChange={(e) => setBody(e.target.value)}
          placeholder="Здравствуйте, {name}!&#10;&#10;Ваше сообщение здесь..."
          rows={8}
          style={{
            width: '100%',
            padding: '12px',
            backgroundColor: COLORS.background,
            border: `1px solid ${COLORS.border}`,
            borderRadius: '8px',
            color: COLORS.text,
            fontSize: '14px',
            resize: 'vertical',
            boxSizing: 'border-box'
          }}
        />
      </div>

      {result && (
        <div style={{
          padding: '12px',
          backgroundColor: `${COLORS.success}20`,
          borderRadius: '8px',
          marginBottom: '16px',
          color: COLORS.success,
          fontSize: '13px'
        }}>
          ✓ Отправлено: {result.success_count} из {selectedClients.length}
          {result.failed_count > 0 && <span style={{ color: COLORS.danger }}> | Ошибок: {result.failed_count}</span>}
        </div>
      )}

      <button
        onClick={handleSend}
        disabled={loading}
        style={{
          width: '100%',
          padding: '14px',
          backgroundColor: loading ? COLORS.border : '#ec4899',
          border: 'none',
          borderRadius: '8px',
          color: loading ? COLORS.textSecondary : '#fff',
          fontSize: '15px',
          fontWeight: '600',
          cursor: loading ? 'not-allowed' : 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px'
        }}
      >
        <Mail size={18} />
        {loading ? 'Отправка...' : 'Отправить Email'}
      </button>
    </ModalWrapper>
  );
};

export default MassEmailModal;
